import Immutable from 'immutable';
import { CASHIN_COLLAPSED_EVENTS_LS } from './constants';
import { LS_FILTER_SHOW_CASHIN, FILTER_SHOW_CASHIN, FILTER_HIDE_CASHIN } from '../../constants';
import { ACTIVE_MATCH_TICKETS_LS } from '../tickets/constants';
import { EXPANDED_MATCH_TICKETS } from '../tickets/handlers';
import { toggleAndUpdateStorage, toggleInDb } from '../../../../common/util';

export const cashinCollapsedInit = db => {
    const lsFilterShowCashin = localStorage.getItem(LS_FILTER_SHOW_CASHIN);
    let newDb = db;
    // not set, set to default
    if (lsFilterShowCashin === null) {
        localStorage.setItem(LS_FILTER_SHOW_CASHIN, FILTER_SHOW_CASHIN);
        newDb = db.setIn(['turboLive', 'filter', 'showCashin'], true);
    }
    return newDb.setIn(
        ['cashin', 'sportEvents', 'collapsed'],
        Immutable.fromJS(JSON.parse(localStorage.getItem(CASHIN_COLLAPSED_EVENTS_LS)) ?? {})
    );
};

export const hideAllCashins = db => {
    const sportEventsIds = db.getIn(['ticketus', 'cashin', 'sportEvents']);
    const sportBetsIds = db.getIn(['ticketus', 'cashin', 'bets']);
    if (sportEventsIds) {
        localStorage.setItem(CASHIN_COLLAPSED_EVENTS_LS, JSON.stringify(sportEventsIds.toJS()));
    }
    localStorage.setItem(LS_FILTER_SHOW_CASHIN, FILTER_HIDE_CASHIN);
    return db
        .setIn(['turboLive', 'filter', 'showCashin'], false)
        .setIn(['cashin', 'sportEvents', 'collapsed'], sportEventsIds)
        .setIn(['cashin', 'bets', 'collapsed'], sportBetsIds);
};

export const showAllCashins = db => {
    localStorage.removeItem(CASHIN_COLLAPSED_EVENTS_LS);
    localStorage.setItem(LS_FILTER_SHOW_CASHIN, FILTER_SHOW_CASHIN);
    localStorage.removeItem(ACTIVE_MATCH_TICKETS_LS);

    return db
        .setIn(['turboLive', 'filter', 'showCashin'], true)
        .setIn(['cashin', 'sportEvents', 'collapsed'], Immutable.fromJS({}))
        .setIn(['cashin', 'bets', 'collapsed'], Immutable.fromJS({}))
        .removeIn(EXPANDED_MATCH_TICKETS);
};

export const cashinAllToggle = db => {
    const showCashin = db.getIn(['turboLive', 'filter', 'showCashin']);
    if (!showCashin) return showAllCashins(db);
    return hideAllCashins(db);
};

export const cashinSportEventToggle = eventId => db => {
    if (!db.getIn(['ticketus', 'cashin', 'sportEvents', eventId])) {
        return db;
    }
    return toggleAndUpdateStorage(db, eventId, ['cashin', 'sportEvents', 'collapsed'], CASHIN_COLLAPSED_EVENTS_LS);
};

export const cashinBetsToggle = betIds => db =>
    betIds.reduce((newDb, betId) => {
        if (!newDb.getIn(['ticketus', 'cashin', 'bets', betId])) {
            return newDb;
        }
        return toggleInDb(newDb, betId, ['cashin', 'bets', 'collapsed']);
    }, db);
